// Minimal markdown -> HTML. Leaves ~~pause~~ and component tags untouched.
const HEADING_EM = { 1: 2, 2: 1.6, 3: 1.3, 4: 1.15, 5: 1, 6: 0.9 };

const inline = (md) => {
  // Pull [text](url) out first so emphasis rules can't mangle underscores in
  // the URL; restore after the rest of the inline pass.
  const links = [];
  const staged = md.replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, (_, text, url) => {
    const i =
      links.push(
        `<a href="${url}" target="_blank" rel="noopener noreferrer">${text}</a>`
      ) - 1;
    return ` ${i} `;
  });
  return staged
    .replace(/^\s*([-*_])\1{2,}\s*$/gm, '<hr />')
    .replace(
      /^(#{1,6})\s+(.*)$/gm,
      (_, hashes, text) =>
        `<strong style="font-size:${HEADING_EM[hashes.length]}em">${text}</strong>`
    )
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/__(.+?)__/g, '<strong>$1</strong>')
    .replace(/\*(.+?)\*/g, '<em>$1</em>')
    .replace(/_([^_\n]+)_/g, '<em>$1</em>')
    .replace(/ (\d+) /g, (_, i) => links[i]);
};

const escapeHtml = (s) =>
  s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

const MONO_FONT =
  "'Berkeley','AAMonoCJK','MS Gothic','Osaka-Mono','Courier New',Courier,monospace";
// Shift-JIS art blocks must draw every glyph — Latin included — from the AA
// font so half-width (0.5em) and full-width (1em) cells stay on one grid.
const AA_FONT = "'AAMonoCJK','MS Gothic','Osaka-Mono',monospace";
const HAS_CJK = /[　぀-ヿ＀-￯]/;

// Odd-indexed parts are inside ``` fences: render verbatim in monospace so
// ASCII art keeps its spacing and underscores aren't eaten by inline markdown.
const markdownToHtml = (md) =>
  md
    .split(/```/)
    .map((part, i) => {
      if (i % 2 === 0) return inline(part);
      const text = part.replace(/^\n/, '').replace(/\n$/, '');
      const aa = HAS_CJK.test(text);
      return `<span class="fence" style="display:inline-block;vertical-align:top;font-family:${
        aa ? AA_FONT : MONO_FONT
      };line-height:${aa ? 1.32 : 1.5};filter:brightness(1.6)">${escapeHtml(
        text
      )}</span>`;
    })
    .join('');

export default markdownToHtml;
